export default __webpack_public_path__ + "static/media/icon_members.562a7e88.svg";